import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Tooltip } from 'react-clone-tippy';
import 'tippy.js/themes/light.css';
import { SVGIcon } from '@superops/super-icons';
import { useCheckFeatureGating } from '@nile/components/src/HOC/withPlanFeatureGating';

function Module(props) {
  const { onClick, index } = props;
  let upSellFeature = false;
  const {
    name,
    label,
    icon,
    newFeatureToolTip,
    featureTag,
    featureGateName = null
  } = props.module;

  if (featureGateName) {
    const feature = useCheckFeatureGating(featureGateName);
    upSellFeature = feature?.upsell;
  }

  return (
    <Tooltip
      html={newFeatureToolTip}
      position="top"
      inertia
      trigger="mouseenter"
      animation="fade"
      theme="tippy-light"
      className="moduleTooltipContent ignoreOverride"
    >
      <ModuleWrapper
        style={{ animationDelay: (index + 1) * 0.1 + 's' }}
        id={label}
        className="sops-grid-wrap ignoreOverride"
        onClick={onClick}
      >
        <SVGIcon name={icon} size="slg" />
        <Title className="sops-module-text position-relative" id={name}>
          <FormattedMessage id={label} />
          {featureTag?.visible ? (
            <span className="feature-tag">{featureTag?.label}</span>
          ) : null}
        </Title>
        {upSellFeature ? (
          <span className="position-absolute right-15">
            <SVGIcon name="Lock" size="sm" color="#6d7175" />
          </span>
        ) : null}
      </ModuleWrapper>
    </Tooltip>
  );
}

const ModuleWrapper = styled.div`
  display: flex;
  padding: 5px 20px;
  cursor: pointer;
  align-items: center;
  }

  &:hover {
    background: var(--sops-lightpurple-to-black-bg);
  }

`;
const Title = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  padding: 0px 20px 0 15px;

  .feature-tag {
    position: absolute;
    right: -30px;
    background-color: rgba(174, 233, 209, 1);
    padding: 0.2rem 0.8rem;
    color: rgba(34, 34, 34, 1);
    border-radius: 4px;
    top: 2px;
    font-size: 1.2rem;
    line-height: 1.6rem;
    font-weight: 400;
  }
`;

export { Module };
